import { render, staticRenderFns } from "./textlist_5_1.vue?vue&type=template&id=4b57d61e&scoped=true"
import script from "./textlist_5_1.vue?vue&type=script&lang=js"
export * from "./textlist_5_1.vue?vue&type=script&lang=js"
import style0 from "./textlist_5_1.vue?vue&type=style&index=0&id=4b57d61e&prod&scoped=true&lang=scss"
import style1 from "./textlist_5_1.vue?vue&type=style&index=1&id=4b57d61e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b57d61e",
  null
  
)

export default component.exports